import React from 'react';
import { FormatCurrency, useLocalize } from '@core-ui/localization-provider';
import RangeFacet from './components/RangeFacet';
import SizeFacet from './components/SizeFacet';
import SimpleFacet from './components/SimpleFacet';
import { Facets, Option } from '../types';

export interface FacetProps {
  appliedFacets: { [property: string]: Option[] };
  facet: Facets;
  isMobile: boolean;
  isSwitchContractEnabled?: boolean;
  onChange: () => void;
}

const shouldUseCurrency = (name: string): boolean => ['price'].includes(name);

const getOptionLabel =
  /* eslint-disable @typescript-eslint/no-explicit-any */
  (name: string, formatCurrency: FormatCurrency) => (option: any) =>
    shouldUseCurrency(name)
      ? formatCurrency(
          option,
          { minimumFractionDigits: 0, maximumFractionDigits: 0 },
          // @ts-ignore
          { option }
        )
      : option;

// eslint-disable-next-line complexity
const Facet = (props: FacetProps) => {
  const { facet, appliedFacets, onChange, isSwitchContractEnabled, isMobile } =
    props;

  const { formatCurrency } = useLocalize();

  switch (facet.type) {
    case 'range':
      return (
        <RangeFacet
          displayName={facet.displayName}
          getOptionLabel={getOptionLabel(facet.name, formatCurrency)}
          maxOptions={facet.maxOptions}
          minOptions={facet.minOptions}
          name={facet.name}
          range={facet.range}
        />
      );
    case 'complex':
      return (
        <SizeFacet onChange={onChange} sizeVariants={facet.sizeVariants} />
      );
    case 'simple':
      return (
        <SimpleFacet
          appliedFacets={appliedFacets}
          facetDisplay={facet.facetDisplay}
          facetLayout={facet.facetLayout}
          facetName={facet.name}
          isMobile={isMobile}
          isSwitchContractEnabled={isSwitchContractEnabled}
          options={facet.options}
        />
      );
    default:
      return null;
  }
};

export default Facet;
